export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAACwAQCdASoQAAYAAsBMJaQAAuRqIMqgAP74HhibF4yDY2E303dCd0hR2kAAAOXVOKAAAA==";